import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useMe = () => {
	return useQuery({
		queryKey: ["partner", "me"],
		queryFn: partnerApiService.getMe,
	});
};
